export interface ITree<T> {
    /**
     * Uložený element v uzlu
     */
    readonly element: T | null;

    /**
     * Podřízené uzly
     */
    children: Iterable<this>;

    /**
     * Vložení nového podřízeného uzlu do tohoto (pod)stromu
     * @param element Vkládaný element
     */
    add(element: T): this;
    /**
     * Vložení nových podřízených uzlů do tohoto (pod)stromu
     * @param element Vkládaný element
     * @returns Vrací uzel do kterého se vkládalo
     */
    addRange(elements: T[]): this;
    /**
     * Vložení nového již vytvořeného podřízeného uzlu do tohoto (pod)stromu
     * @param element Vkládaný element
     */
    addNode(node: this): this;
    /**
     * Vložení nových již vytvořených podřízených uzlu do tohoto (pod)stromu
     * @param element Vkládaný element
     * @returns Vrací uzel do kterého se vkládalo
     */
    addNodeRange(nodes: this[]): this;
    /**
     * Vložení nového podřízené uzlu do (pod)stromu reprezentovaného předaným elementem. Pokud není ve stromu nalezen, tak se vloží do současného (pod)stromu
     * @param element Vkládaný element
     * @param parent Rodičovský uzel, do kterého by se měl element vložit
     */
    addToNode(element: T, parent: T): this | null;
    /**
     * Pokusí se ve stromě najít hledaný uzel a pokud byl nalezen, odstraní jej.
     * @param node Uzel k odstranění
     * @returns Vrací true, pokud se podařilo uzel odstranit.
     */
    removeNode(node: this): boolean;
    /**
     * Odstraní uzel, který je přímým potmkem aktuálního uzlu
     * @param node Uzel k odstranění
     * @returns Vrací true, pokud se podařilo uzel odstranit.
     */
    removeChildNode(node: this): boolean;
    /**
     * Najde podstrom se zadaným elementem nebo null, pokud nebyl nalezen
     * @param element
     */
    findByElement(element: T): this | null;
    /**
     * Nahradí současný uzel za předaný uzel.
     * @param node Uzel, který má nahradit stávající uzel.
     * @returns Nový uzel
     */
    replaceNode(node: this): this;
    /**
     * Vrací, zda má aktuální uzel v přímých potomcích hledaný uzel
     * @param node Uzel ko kontrole potomků
     */
    hasChildNode(node: this): boolean;
    /**
     * Průchodem do hloubky navštíví všechny uzly
     * @param visitor Funkce spouštěná nad každým uzlem
     */
    traverseDFS(visitor: (data: T | null) => void): void;
}
